import React from "react";
import Title from "../layouts/Title";
import {
  projectOne,
  projectTwo,
  projectThree,
  projectFour,
  projectFive,
} from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="DevSecOps CI/CD Pipeline"
          des="Complete CI/CD pipeline for 4 microservices — automated build, Trivy + OWASP Dependency Check + SonarQube security gates, and Kubernetes deployment in a single run. Vulnerabilities block deployment automatically. Real-time monitoring with Prometheus + Grafana."
          src={projectOne}
          github="https://github.com/bipro-b/micro-service-kafka"
          live="https://github.com/bipro-b/micro-service-kafka"
        />
        <ProjectsCard
          title="Blue-Green Zero-Downtime Deployment"
          des="Zero-downtime Blue-Green deployment strategy using Docker containers and NGINX traffic switching between ports. Automated full pipeline (build → push → deploy → switch) with GitHub Actions — push to main goes live in under 5 minutes."
          src={projectTwo}
          github="https://github.com/bipro-b/Inventory_Management"
          live="https://github.com/bipro-b/Inventory_Management"
        />
        <ProjectsCard
          title="Kubernetes Cluster Deployments"
          des="Provisioned multi-node Kubernetes clusters on AWS EC2 using kubeadm — full cluster lifecycle from bootstrap to production-ready. Deployed microservices with Helm charts and Ingress controllers; explored AWS EKS for managed Kubernetes at scale."
          src={projectThree}
          github="https://github.com/bipro-b/k8s-kubeadm"
          live="https://github.com/bipro-b/k8s-minikube"
        />
        <ProjectsCard
          title="Bipro-Estate"
          des="Real estate web application with User Authentication and Authorization using Email, Google Auth, and JWT. Features include real estate listing search, authenticated listing management, private routes, Firebase image storage, and fully responsive design."
          src={projectFour}
          github="https://github.com/bipro-b/bipro_estate"
          live="https://bipro-estate.onrender.com/search"
        />
        <ProjectsCard
          title="Inventory Management System"
          des="Backend stock management system where inventory relates to brands, products, stores, suppliers, and users. Implements Authentication, Authorization, and role management with full CRUD operations via REST API architecture."
          src={projectFive}
          github="https://github.com/bipro-b/Inventory_Management"
          live="https://www.youtube.com/watch?v=EGEYcxr_Zxw&t=54s"
        />
        <ProjectsCard
          title="CUET IT Incubator"
          des="Backend application featuring relational data models, JWT-based user authentication and authorization, and complete CRUD operations built on REST API architecture. Developed for the CUET IT Incubator platform."
          src={projectOne}
          github="https://github.com/bipro-b/CUET-IT-INCUBATOR"
          live="https://www.youtube.com/watch?v=VH79fRSZw64&t=587s"
        />
      </div>
    </section>
  );
};

export default Projects;